import moment from "moment-timezone";
import axios from "axios";

/**
 * Detect environment
 */
const TEST_ORIGINS = [
  "https://devattportal.uslegalservices.net",
  "http://localhost:8080",
  "http://localhost:8081",
  "https://legattorney.legalia.com",
];

const isTestEnv = TEST_ORIGINS.includes(window.location.origin);
const ENV = isTestEnv ? "test" : "prod";
/**
 * Environment based config
 */
const CONFIG = {
  test: {
    API_BASE: "https://devapi.uslegalservices.net/api/attorney_portal/",
    CLAIM_BASE: "https://devapi.uslegalservices.net/api/attorney_claims/v2/",
    AGEN_API: "https://devapi.uslegalservices.net/api/agent/",
    MS_BASE: "https://devms.uslegalservices.net/usl",
    EMAIL_URL:
      "https://b9qw7pgpx5.execute-api.us-east-1.amazonaws.com/emailFifoProducer",
    SELECTED_TRUE:
      "https://81omgd2sb0.execute-api.us-east-1.amazonaws.com/api/checkSelectedTrue",
    GENERATE_TOKEN:
      "https://81omgd2sb0.execute-api.us-east-1.amazonaws.com/api/generateToken",
    START_STATE_MACHINE:
      "https://81omgd2sb0.execute-api.us-east-1.amazonaws.com/api/startFeeScheduleStateMachine",
    HS_KEY: "83e9e6fb8fc867b64930cbb8e145facd",
    IS_TEST: true,
    BUCKET_NAME: "usltestlambda3",
    S3_TEMPLATE_PATH: "storage/email_templates/Test",
  },

  prod: {
    API_BASE: "https://api.uslegalservices.net/api/attorney_portal/",
    CLAIM_BASE: "https://api.uslegalservices.net/api/attorney_claims/v2/",
    AGEN_API: "https://api.uslegalservices.net/api/agent/",
    MS_BASE: "https://usl.uslegalservices.net/usl",
    EMAIL_URL:
      "https://qjvgj2c33c.execute-api.us-east-1.amazonaws.com/emailFifoProducer",
    SELECTED_TRUE:
      "https://by2cb8mto2.execute-api.us-east-1.amazonaws.com/api/checkSelectedTrue",
    GENERATE_TOKEN:
      "https://by2cb8mto2.execute-api.us-east-1.amazonaws.com/api/generateToken",
    START_STATE_MACHINE:
      "https://by2cb8mto2.execute-api.us-east-1.amazonaws.com/api/startFeeScheduleStateMachine",
    HS_KEY: "f3c2738874829d6895be9e57f3c37103",
    IS_TEST: false,
    BUCKET_NAME: "usltestlambda3",
    S3_TEMPLATE_PATH: "storage/email_templates/Production",
  },
};

/**
 * Static constants (same for all envs)
 */
const documentTitle = "Attorney Application";
const SHARP_SPRINT_API_BASE = "https://api.sharpspring.com/pubapi/v1";
const SECRET_KEY = "MO142kXCFMpvVucyzZ8399e439DSD8Jd6rZO";
const ED_KEY = "123jsdkaha45sd54asd5as4d654";
const BASE_S3 = "https://uslawstests3.s3.amazonaws.com";
const API_TOKEN = "QOivgNXf175SF54_ODLxzJ9TkFIPbq806-LmgyVZ594";
const AWS_REGION = "us-east-1";
/**
 * Utils
 */
const setDateFormat = (date) => {
  if (date && date !== "0000-00-00 00:00:00") {
    return moment(date).format("MM/DD/YYYY");
  }
  return "";
};

const s3Url = (key) => {
  const { BUCKET_NAME, S3_TEMPLATE_PATH } = CONFIG[ENV];
  return `https://${BUCKET_NAME}.s3.${AWS_REGION}.amazonaws.com/${S3_TEMPLATE_PATH}/${key}.html`;
};

const sendMail = (payload) => {
  if (!payload?.toemail || !payload?.subject || !payload?.templateS3Url) {
    return Promise.reject({
      message: "toemail, subject, and template are required",
    });
  }

  payload.variables = payload.variables || {};
  payload.variables.original_toemail = payload.toemail;
  payload.variables.original_ccemail = payload.ccemail;
  payload.variables.original_bccemail = payload.bccemail;

  payload.replyTo = null;

  return axios.post(CONFIG[ENV].EMAIL_URL, payload, {
    headers: { token: API_TOKEN },
  });
};
const encryptF = (string) => {
  const key = ED_KEY;
  let result = "";

  for (let i = 0; i < string.length; i++) {
    const charCode = string.charCodeAt(i);

    // PHP equivalent: substr($key, ($i % strlen($key))-1, 1)
    let keyIndex = (i % key.length) - 1;
    if (keyIndex < 0) keyIndex = key.length - 1;

    const keyCharCode = key.charCodeAt(keyIndex);

    result += String.fromCharCode(charCode + keyCharCode);
  }

  // Browser-compatible base64 encoding
  return btoa(result);
};
const decryptF = (encodedStr) => {
  const key = ED_KEY;
  let result = "";

  const decodedStr = atob(encodedStr);

  for (let i = 0; i < decodedStr.length; i++) {
    // Calculate index like PHP substr negative index
    let idx = (i % key.length) - 1;
    if (idx < 0) idx = key.length + idx; // wrap around like PHP

    const char = decodedStr.charAt(i);
    const keychar = key.charAt(idx);
    const decryptedChar = String.fromCharCode(
      char.charCodeAt(0) - keychar.charCodeAt(0)
    );
    result += decryptedChar;
  }

  return result;
};
const maskString=(inputString, n) =>{
  // Get the length of the string
  const length = inputString.length;

  // If the string is shorter than or equal to n, return the original string
  if (length <= n) {
    return inputString;
  }

  // Get the last n characters
  const lastNCharacters = inputString.slice(-n);

  // Create a string with asterisks for the remaining characters
  const maskedString = '*'.repeat(length - n) + lastNCharacters;

  return maskedString;
}

/**
 * 
 * Export
 */
export default {
  decryptF,
  encryptF,
  sendMail,
  maskString,
  s3Url,
  ENV,
  setDateFormat,
  documentTitle,
  API_BASE: CONFIG[ENV].API_BASE,
  CLAIM_BASE: CONFIG[ENV].CLAIM_BASE,
  AGEN_API: CONFIG[ENV].AGEN_API,
  MS_BASE: CONFIG[ENV].MS_BASE,
  SELECTED_TRUE: CONFIG[ENV].SELECTED_TRUE,
  GENERATE_TOKEN: CONFIG[ENV].GENERATE_TOKEN,
  START_STATE_MACHINE: CONFIG[ENV].START_STATE_MACHINE,
  SHARP_SPRINT_API_BASE,
  SECRET_KEY,
  HS_KEY: CONFIG[ENV].HS_KEY,
  BASE_S3,
  IS_TEST: CONFIG[ENV].IS_TEST,
};
